// from https://codesandbox.io/s/v1vkm8mol0
import React from "react";
import { List } from "react-virtualized";

function defaultEasing(delta) {
  return delta;
}

export default class AnimatedList extends React.Component {
  static defaultProps = {
    duration: 1000,
    easing: defaultEasing,
    onAnimationComplete: () => {}
  };

  listRef = React.createRef();

  state = {
    scrollTop: null
  };

  componentDidMount() {
    if (this.props.scrollToIndex) {
      this._initAnimation();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.scrollToIndex !== prevProps.scrollToIndex) {
      this._initAnimation();
    }
  }

  render() {
    return (
      <List
        {...this.props}
        onScroll={this.onScroll}
        ref={this.listRef}
        scrollToIndex={undefined}
        scrollTop={this.state.scrollTop}
      />
    );
  }

  _animate() {
    requestAnimationFrame(() => {
      const { duration, easing } = this.props;
      const now = performance.now();
      const ellapsed = now - this._animationStartTime;
      const scrollDelta = this._scrollTopFinal - this._scrollTopInitial;
      const easedTime = easing(Math.min(1, ellapsed / duration));
      const scrollTop = this._scrollTopInitial + scrollDelta * easedTime;

      this.setState({ scrollTop });

      if (ellapsed < duration) {
        this._animate();
      } else {
        this._animationStartTime = undefined;
        this._scrollTopInitial = this._scrollTopFinal;
        this.props.onAnimationComplete();

        this.setState({ scrollTop: null });
      }
    });
  }

  _initAnimation() {
    const { scrollToIndex } = this.props;

    if (!this._animationStartTime) {
      this._animationStartTime = performance.now();
    }

    // Ask List for the offset in case it's complex;
    // eg CellMeasurer might be involved and we don't want to duplicate effort
    this._scrollTopFinal = this.listRef.current.getOffsetForRow({
      index: scrollToIndex,
      alignment: 'center'
    });

    this._animate();
  }

  onScroll = ({ scrollTop }) => {
    if (!this._animationStartTime) {
      this._scrollTopInitial = scrollTop;
    }
  };
}
